import React from 'react'
import { Link } from 'react-router-dom'

export default () => (
  <dev className="home">
   

   
    <h1 className="title">Walden Tax Advisory</h1>

    <p>At Walden we focus on the things that matter: the core of your business.</p>
    <p></p>
     <p>
      Hi, my name is Josh Ho. I am a Certified Practising Accountant and Registered Tax Agent specialising in Australian Taxation, Business Finance and Valuation, Strategies and Improvement.
    </p>

    <p>
     You can check out my <Link to="/skills">skills</Link> and <Link to="/projects">projects</Link> .
    </p>

    <p>Liability limited by a scheme approved under Professional Standards Legislation</p>


  </dev>
)



// WEBPACK FOOTER //
// ./src/components/Home.js